import { UserFacingError } from './errors'

export class InvoiceNotEditableError extends UserFacingError {
  constructor() {
    super('This invoice can no longer be edited.')
    this.name = 'InvoiceNotEditableError'
  }
}

export class InvoiceNotVoidableError extends UserFacingError {
  constructor() {
    super('This invoice cannot be voided in its current state.')
    this.name = 'InvoiceNotVoidableError'
  }
}

export class InvoiceNotRefundableError extends UserFacingError {
  constructor() {
    super('This invoice cannot be refunded.')
    this.name = 'InvoiceNotRefundableError'
  }
}

export class RefundExceedsPaidError extends UserFacingError {
  constructor() {
    super('Refund amount cannot exceed the amount paid.')
    this.name = 'RefundExceedsPaidError'
  }
}

export class MissingRefundReasonError extends UserFacingError {
  constructor() {
    super('A refund reason is required.')
    this.name = 'MissingRefundReasonError'
  }
}

export class DuplicateInvoiceError extends UserFacingError {
  constructor() {
    super('An invoice of this type already exists for this booking.')
    this.name = 'DuplicateInvoiceError'
  }
}

export class InvoiceAmountExceedsBalanceError extends UserFacingError {
  readonly remainingBalance?: number

  constructor(remainingBalance?: number) {
    super('Invoice amount exceeds the remaining booking balance.')
    this.name = 'InvoiceAmountExceedsBalanceError'
    this.remainingBalance = remainingBalance
  }
}

export class MissingRecipientEmailError extends UserFacingError {
  constructor(message: string) {
    super(message)
    this.name = 'MissingRecipientEmailError'
  }
}

export class ProviderNotConnectedError extends UserFacingError {
  constructor(message = 'Stripe is not connected for this outfitter.') {
    super(message)
    this.name = 'ProviderNotConnectedError'
  }
}

export class FinanceCustomerNotFoundError extends UserFacingError {
  constructor() {
    super('Customer not found.')
    this.name = 'FinanceCustomerNotFoundError'
  }
}

export class ExportTooLargeError extends UserFacingError {
  constructor() {
    super('This export is too large to generate now. Async export is coming soon.')
    this.name = 'ExportTooLargeError'
  }
}

export class ReportTimedOutError extends UserFacingError {
  constructor() {
    super('This report took too long to generate. Try a shorter date range.')
    this.name = 'ReportTimedOutError'
  }
}

export class PackageReferencedByInvoiceError extends UserFacingError {
  constructor() {
    super(
      'This package cannot be deleted because it is used on one or more invoices. Remove it from those invoices first.',
    )
    this.name = 'PackageReferencedByInvoiceError'
  }
}
